export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_REQUEST_SUCCESS = 'CREATE_ORDER_REQUEST_SUCCESS';
export const CREATE_ORDER_REQUEST_FAILURE = 'CREATE_ORDER_REQUEST_FAILURE';

export const CANCEL_COLLECTION_REQUEST = 'CANCEL_COLLECTION_REQUEST';
export const CANCEL_COLLECTION_REQUEST_SUCCESS = 'CANCEL_COLLECTION_REQUEST_SUCCESS';
export const CANCEL_COLLECTION_REQUEST_FAILURE = 'CANCEL_COLLECTION_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/create_order.constants.js